import { render, staticRenderFns } from "./mask_Component.vue?vue&type=template&id=273cf7ae&scoped=true&"
import script from "./mask_Component.vue?vue&type=script&lang=js&"
export * from "./mask_Component.vue?vue&type=script&lang=js&"
import style0 from "./mask_Component.vue?vue&type=style&index=0&id=273cf7ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273cf7ae",
  null
  
)

export default component.exports